export class ComparedValueEntity {
  current!: number
  previous!: number
  diff!: number
}

export type SortByEntity = 'buy_now_clicks' | 'presale_codes' | 'meet_and_greet' | 'vip' | 'rsvp'
export type SortOrderEntity = 'asc' | 'desc'

export class EventItemEntity {
  event!: string | null
  city!: string
  num_events!: number
  buy_now_clicks!: ComparedValueEntity
  presale_codes!: ComparedValueEntity
  meet_and_greet!: ComparedValueEntity
  vip!: ComparedValueEntity
  rsvp!: ComparedValueEntity
}

export class EventsPageEntity {
  total!: number
  items!: EventItemEntity[]
}

export class EventsTotalsEntity {
  buy_now_clicks!: ComparedValueEntity
  presale_codes!: ComparedValueEntity
  meet_and_greet!: ComparedValueEntity
  vip!: ComparedValueEntity
  rsvp!: ComparedValueEntity
}
